import { useTheme as b, getSafeGutter as p, getSizeValue as k } from "@bedrock-layout/spacing-constants";
import { forwardRefWithAs as y } from "@bedrock-layout/type-utils";
import e from "react";
function E(t, r) {
  return k(t, r);
}
const S = y(
  ({
    as: t,
    children: r,
    gutter: n,
    top: o,
    bottom: a,
    minHeight: i,
    style: m,
    stretchContent: d,
    ...s
  }, f) => {
    const c = b(), u = p(c, n), v = E(c, i), l = d === !0 ? "stretch-content" : "", g = m ?? {}, h = t ?? "div";
    return /* @__PURE__ */ e.createElement(
      h,
      {
        ref: f,
        "data-bedrock-cover": l,
        style: {
          ...g,
          "--gutter": u,
          "--minHeight": v
        },
        ...s
      },
      o && /* @__PURE__ */ e.createElement("div", { "data-bedrock-cover-top": "" }, o),
      /* @__PURE__ */ e.createElement("div", { "data-bedrock-cover-centered": "" }, r),
      a && /* @__PURE__ */ e.createElement("div", { "data-bedrock-cover-bottom": "" }, a)
    );
  }
);
S.displayName = "Cover";
export {
  S as Cover
};
